import React, { useEffect } from 'react'
import Header from './Header'
import CarouselSection from './CarouselSection'
import { useDispatch, useSelector } from 'react-redux'
import { getProducts } from '../../redux/actions/productActions'
import Slide from './Slide'
import Timer from './Timer'
import Tabs from './Tabs'



const Home = () => {
  const {products}=useSelector(state=>state.getProducts);
  // console.log('start');
  console.log(products);
  // console.log('end');

  const dispatch=useDispatch();
  useEffect(() => {
    dispatch(getProducts());
  }, [dispatch])
  return (
    <>
      {/* <Header/> */}
      <Tabs/>
      <Timer/>
      <CarouselSection/>
      <Slide products={products} title='Deal of the day'/>
      <Slide products={products} title='Top picks for you'/>
      <Slide products={products} title='Discount'/>
      <Slide products={products} title='Offers'/>
    </>
  )
}

export default Home
